// apps/client/src/components/errors/ErrorTemplate.tsx
import React from 'react';
import { Box, Typography, Button, Container } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { SentimentVeryDissatisfied } from '@mui/icons-material';

export const ErrorButtons = {
  HOME: 'home',
  LOGIN: 'login',
  REFRESH: 'refresh',
  BACK: 'back',
};

interface ErrorTemplateProps {
  title: string;
  heading: string;
  message: string;
  buttons: string[];
  icon?: React.ReactNode;
}

export const ErrorTemplate: React.FC<ErrorTemplateProps> = ({
  title,
  heading,
  message,
  buttons,
  icon = <SentimentVeryDissatisfied sx={{ fontSize: '6rem', mb: 2, color: 'text.secondary' }} />,
}) => {
  const navigate = useNavigate();

  const handleRefresh = () => {
    window.location.reload();
  };

  return (
    <Container maxWidth="sm">
      <Box
        display="flex"
        flexDirection="column"
        alignItems="center"
        justifyContent="center"
        minHeight="80vh"
        textAlign="center"
      >
        {icon}
        <Typography variant="h3" component="h1" gutterBottom color="primary">
          {title}
        </Typography>

        <Typography variant="h5" component="h2" gutterBottom>
          {heading}
        </Typography>

        <Typography variant="body1" color="text.secondary" sx={{ mb: 4, maxWidth: '400px' }}>
          {message}
        </Typography>

        <Box sx={{ display: 'flex', gap: 2 }}>
          {buttons.includes(ErrorButtons.HOME) && (
            <Button variant="contained" onClick={() => navigate('/')}>
              Go Home
            </Button>
          )}
          {buttons.includes(ErrorButtons.LOGIN) && (
            <Button variant="contained" onClick={() => navigate('/login')}>
              Login
            </Button>
          )}
          {buttons.includes(ErrorButtons.REFRESH) && (
            <Button variant="contained" onClick={handleRefresh}>
              Refresh Page
            </Button>
          )}
          {buttons.includes(ErrorButtons.BACK) && (
            <Button variant="outlined" onClick={() => navigate(-1)}>
              Go Back
            </Button>
          )}
        </Box>
      </Box>
    </Container>
  );
};

export default ErrorTemplate;
